// P7 (2026-11-02) — Email verification landing page.

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { api, formatApiError } from "../lib/api";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [state, setState] = useState("idle");
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(null);

  async function submit(e) {
    e && e.preventDefault();
    setState("busy"); setErr(null);
    try {
      const r = await api.post("/public/verify-email", { token });
      setDone(r.data || {});
      setState("done");
      // After a brief pause, bounce them into the onboarding checklist.
      setTimeout(() => navigate("/brand-os/onboarding"), 1200);
    } catch (e2) {
      setErr(formatApiError(e2));
      setState("error");
    }
  }

  useEffect(() => {
    if (params.get("token")) submit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bo-root" data-testid="verify-email-screen">
      <div className="bo-login-shell">
        <form className="bo-login-card" onSubmit={submit}>
          <div className="bo-login-eyebrow">Precipice Brand OS</div>
          <h1 className="bo-login-title">Verify your email</h1>

          {state === "done" && (
            <div data-testid="verify-email-done">
              <p>You're in. Loading your workspace…</p>
            </div>
          )}

          {state !== "done" && (
            <>
              <label className="bo-label">Verification token</label>
              <input
                className="bo-input"
                data-testid="verify-email-token"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Paste the token from your email"
                required
              />
              {err && (
                <div data-testid="verify-email-error"
                     style={{ color: "crimson", marginTop: 10 }}>
                  {typeof err === "string" ? err : err.message || JSON.stringify(err)}
                </div>
              )}
              <button
                className="bo-btn"
                type="submit"
                data-testid="verify-email-submit"
                disabled={state === "busy" || !token}
                style={{ width: "100%", marginTop: 16 }}
              >
                {state === "busy" ? "Verifying…" : "Verify and continue"}
              </button>
              <p style={{ marginTop: 10, fontSize: 13 }}>
                <Link to="/brand-os/signup">← Back to signup</Link>
              </p>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
